import React from 'react';

import { Alert, Grid } from '@mui/material';

import { PopulationRegister } from '../../../../utilities/schemas/populationRegister';

type Record = PopulationRegister['record'];

const WITHHELD_DATA = 'The register withholds some or all of this person\'s data, so parts of this report may be empty.';

// SPAR flags a protected registration either directly or through secrecySetBySpar.
// Returns undefined when SPAR sent neither field, so the view can show "-" instead of "No".
export const getProtectedRegistration = (record?: Record) => {
  const flags = [record?.protectedRegistration, record?.secrecy?.secrecySetBySpar];
  if (flags.some((flag) => flag === true)) return true;
  if (flags.some((flag) => flag === false)) return false;
  return undefined;
};

const PopulationRegisterSecrecyAlerts = ({
  record,
}: {
  record?: Record;
}) => {
  const hasSecrecy = !!record?.secrecy?.secrecy;
  const hasProtectedRegistration = !!getProtectedRegistration(record);

  if (!hasSecrecy && !hasProtectedRegistration) return null;

  // A protected registration usually comes with a secrecy marker and is the stronger protection,
  // so it takes precedence and only one alert is shown.
  const marker = hasProtectedRegistration
    ? 'This individual has a protected population registration.'
    : 'This individual has a secrecy marker.';

  return (
    <Grid container justifyContent="center">
      <Alert severity="warning">
        {`${marker} ${WITHHELD_DATA}`}
      </Alert>
    </Grid>
  );
};

export default PopulationRegisterSecrecyAlerts;
